import React from 'react';
import Logo from './Logo';
import { brand, navLinks, subjects } from '../mock';
import { Instagram, Facebook, Linkedin, Youtube, Phone, Mail, MapPin } from 'lucide-react';

export default function Footer() {
  return (
    <footer className="bg-[#FFF8EC] border-t-2 border-[#2C3E50]">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 py-14 grid lg:grid-cols-12 gap-10">
        <div className="lg:col-span-4">
          <Logo />
          <p className="mt-4 text-[#2C3E50]/75 font-medium leading-relaxed max-w-sm">
            Experienced home tutors for every class and every subject. Now available online across Pan India.
          </p>
          <div className="mt-5 flex gap-2">
            {[
              { Icon: Instagram, href: 'https://www.instagram.com/pikachuclasses/', bg: '#E64B2B', label: 'instagram' },
              { Icon: Facebook, href: '#', bg: '#7BB7DC', label: 'facebook' },
              { Icon: Linkedin, href: '#', bg: '#2C3E50', label: 'linkedin' },
              { Icon: Youtube, href: '#', bg: '#F4B93E', label: 'youtube' }
            ].map(({ Icon, href, bg, label }) => (
              <a key={label} href={href} target="_blank" rel="noreferrer" aria-label={label} style={{ background: bg }} className="w-10 h-10 rounded-lg text-white flex items-center justify-center border-2 border-[#2C3E50] hover:-translate-y-0.5">
                <Icon size={18} />
              </a>
            ))}
          </div>
        </div>

        <div className="lg:col-span-2">
          <div className="text-xs uppercase tracking-widest font-black text-[#2C3E50]/60 mb-3">Explore</div>
          <ul className="space-y-2">
            {navLinks.map((l) => (
              <li key={l.href}><a href={l.href} className="font-bold text-[#2C3E50] hover:text-[#E64B2B]">{l.label}</a></li>
            ))}
          </ul>
        </div>

        <div className="lg:col-span-3">
          <div className="text-xs uppercase tracking-widest font-black text-[#2C3E50]/60 mb-3">Popular subjects</div>
          <ul className="grid grid-cols-2 gap-y-2">
            {subjects.slice(0, 6).map((s) => (
              <li key={s.name}><a href="#subjects" className="font-bold text-[#2C3E50] hover:text-[#E64B2B]">{s.name}</a></li>
            ))}
          </ul>
        </div>

        <div className="lg:col-span-3">
          <div className="text-xs uppercase tracking-widest font-black text-[#2C3E50]/60 mb-3">Get in touch</div>
          <ul className="space-y-3">
            <li className="flex gap-3 items-start"><Phone size={18} className="text-[#E64B2B] mt-0.5" /><a href={`tel:${brand.phoneRaw}`} className="font-bold">{brand.phone}</a></li>
            <li className="flex gap-3 items-start"><Phone size={18} className="text-[#4FB3B8] mt-0.5" /><a href={`tel:${brand.phone2Raw}`} className="font-bold">{brand.phone2}</a></li>
            <li className="flex gap-3 items-start"><Mail size={18} className="text-[#4FB3B8] mt-0.5" /><a href={`mailto:${brand.email}`} className="font-bold break-all">{brand.email}</a></li>
            <li className="flex gap-3 items-start"><Mail size={18} className="text-[#F4B93E] mt-0.5" /><a href={`mailto:${brand.email2}`} className="font-bold break-all">{brand.email2}</a></li>
            <li className="flex gap-3 items-start"><MapPin size={18} className="text-[#F4B93E] mt-0.5" /><span className="font-bold">{brand.address}</span></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-[#2C3E50]/15">
        <div className="max-w-7xl mx-auto px-5 lg:px-8 py-5 flex flex-col sm:flex-row items-center justify-between gap-3 text-sm text-[#2C3E50]/70 font-semibold">
          <div>© {new Date().getFullYear()} Pikachu Classes. All rights reserved.</div>
          <div className="flex gap-5">
            <a href="#" className="hover:text-[#E64B2B]">Privacy</a>
            <a href="#" className="hover:text-[#E64B2B]">Terms</a>
            <a href="#" className="hover:text-[#E64B2B]">Refund Policy</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
